import { gql } from "@apollo/client";

export const GET_OVERVIEW_SAVED_VIEWS = gql`
  query GetOverviewSavedViews {
    me {
      id
      overviewSavedViews
    }
  }
`;

export const CREATE_OVERVIEW_SAVED_VIEW = gql`
  mutation CreateOverviewSavedView($name: String!, $config: JSONObject!) {
    createOverviewSavedView(name: $name, config: $config)
  }
`;

export const UPDATE_OVERVIEW_SAVED_VIEW = gql`
  mutation UpdateOverviewSavedView(
    $id: Int!
    $name: String
    $config: JSONObject
  ) {
    updateOverviewSavedView(id: $id, name: $name, config: $config)
  }
`;

export const UPDATE_OVERVIEW_SAVED_VIEW_ORDERING = gql`
  mutation UpdateOverviewSavedViewOrdering($ids: [Int!]!) {
    updateOverviewSavedViewOrdering(ids: $ids)
  }
`;

export const UPDATE_OVERVIEW_SAVED_VIEW_ORDERING_TO_ALL_ACCOUNT_MANAGERS = gql`
  mutation UpdateOverviewSavedViewOrderingToAllAccountManagers($ids: [Int!]!) {
    updateOverviewSavedViewOrderingToAllAccountManagers(ids: $ids)
  }
`;

export const DELETE_OVERVIEW_SAVED_VIEW = gql`
  mutation DeleteOverviewSavedView($id: Int!) {
    deleteOverviewSavedView(id: $id)
  }
`;
export const CREATE_HIDDEN_OVERVIEW_SAVED_VIEW_TEMPLATE = gql`
  mutation CreateHiddenOverviewSavedViewTemplate($id: Int!) {
    createClientHiddenOverviewSavedViewTemplate(id: $id)
  }
`;
